import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './component/Authcontext';

ReactDOM.render(
  <React.StrictMode>
     <AuthProvider>
      <App />
     </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);


reportWebVitals();
